import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const API_URL = "/api";

export const benefitApi = createApi({
  reducerPath: "benefitApi",
  baseQuery: fetchBaseQuery({ baseUrl: API_URL }),
  endpoints: (builder) => ({
    AddBenefit: builder.mutation({
      query: ({ Token, data }) => ({
        url: "/admin/benefit",
        method: "POST",
        headers: {
          Authorization: `Bearer ${Token}`,
        },
        body: data,
      }),
      providesTags: ["benefits"],
      invalidatesTags: ["benefits"],
    }),
    getAllBenefit: builder.query({
      query: (Token) => ({
        url: "/admin/benefit",
        method: "GET",
        headers: {
          Authorization: `Bearer ${Token}`,
        },
      }),
      providesTags: ["benefits"],
      invalidatesTags: ["benefits", "benefit"],
    }),
    UpdateBenefit: builder.mutation({
      query: ({ benefitId, Token, data }) => ({
        url: `/admin/benefit/${benefitId}`,
        method: "PUT",
        headers: {
          Authorization: `Bearer ${Token}`,
        },
        body: data,
      }),
      invalidatesTags: ["benefits"],
    }),
    DeleteBenefit: builder.mutation({
      query: ({ benefitId, Token }) => ({
        url: `/admin/benefit/${benefitId}`,
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${Token}`,
        },
      }),
      invalidatesTags: ["benefits"],
    }),
  }),
});

export const {
  useAddBenefitMutation,
  useDeleteBenefitMutation,
  useGetAllBenefitQuery,
  useUpdateBenefitMutation,
} = benefitApi;
